import { render, staticRenderFns } from "./Tune.vue?vue&type=template&id=05ed56aa&scoped=true&"
import script from "./Tune.vue?vue&type=script&lang=js&"
export * from "./Tune.vue?vue&type=script&lang=js&"
import style0 from "./Tune.vue?vue&type=style&index=0&id=05ed56aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ed56aa",
  null
  
)

export default component.exports